import ErrorComponent from "../Components/ErrorComponent/ErrorComponent";
import TestingComponent from "../Components/TestingComponent/TestingComponent";
import AirbusAssetList from "../Pages/Main/AirbusAsset/AirbusAssetList";
import AssetList from "../Pages/Main/Asset/AssetList";
import CreateAsset from "../Pages/Main/Asset/CreateAsset";
import Home from "../Pages/Main/Home/Home";
import CreateShow from "../Pages/Main/Show/CreateShow";
import ShowDetails from "../Pages/Main/Show/ShowDetails";
import ShowList from "../Pages/Main/Show/ShowList";
import CreateShowAssets from "../Pages/Main/ShowAssets/CreateShowAssets";


const routes = [
    { path: "/", component: Home, name: "HomeComponent", element: Home },
    { path: "/CreateShow", component: CreateShow, name: "CreateShow", element: CreateShow },
    { path: "/ShowList", component: ShowList, name: "ShowList", element: ShowList },
    { path: "/AirbusAssetList", component: AirbusAssetList, name: "AirbusAssetList", element: AirbusAssetList },
    { path: "/showDetails/:id", component: ShowDetails, name: "ShowDetails", element: ShowDetails },
    { path: "/CreateAsset", component: CreateAsset, name: "CreateAsset", element: CreateAsset },
    { path: "/CreateShowAssets", component: CreateShowAssets, name: "CreateShowAssets", element: CreateShowAssets },
    { path: "/AssetList", component: AssetList, name: "AssetList", element: AssetList },
    { path: "/Testing", component: TestingComponent, name: "TestingComponent", element: TestingComponent },
    { path: "*", component: ErrorComponent, name: "ErrorComponent", element: ErrorComponent },
]
export default routes;